export default __webpack_public_path__ + "static/media/song.9a7ac162.mp3";